export enum LanguageType {
  enEN = 1,
  deDE = 2,
  ruRU = 3,
  LA = 4,
  Description = 5,
}

export enum LocalizationType {
  /**
   * Translation keys for admins
   */
  LA = 'LA',
  enEN = 'enEN',
  deDE = 'deDE',
  ruRU = 'ruRU',
}

export enum LocaleType {
  Description = '!Descriptions',
  LA = '!L-A',
  enEN = 'en-EN',
  deDE = 'de-DE',
  ruRU = 'ru-RU',
}

const LOCALIZATION_VALUE_MAP: { [key in LocalizationType]: LocaleType } = {
  [LocalizationType.LA]: LocaleType.LA,
  [LocalizationType.enEN]: LocaleType.enEN,
  [LocalizationType.deDE]: LocaleType.deDE,
  [LocalizationType.ruRU]: LocaleType.ruRU,
} as const;

export function convertLocalizationToLocale(localization: LocalizationType): LocaleType {
  return LOCALIZATION_VALUE_MAP[localization];
}

export function convertLocaleToLocalization(localization: LocaleType): LocalizationType {
  const keys = Object.keys(LOCALIZATION_VALUE_MAP) as LocalizationType[];
  const foundedLocale = keys.find((k) => LOCALIZATION_VALUE_MAP[k] === localization);

  return foundedLocale ?? LocalizationType.enEN;
}
